module.exports = __webpack_public_path__ + "static/media/zimswitch.2606b178.svg";